module.exports = __webpack_public_path__ + "0bbb35404bc381fde5c0938a540b6be8.svg";